import { Controller } from '@hotwired/stimulus';
import application from '~/stimulus_application';

/**
 * Stimulus controller for switching between media type panels with a select.
 * Shows the panel of the selected media type and the Internal badge for internal ones.
 */
export default class MediaTypeSwitchController extends Controller {
  static targets = ['select', 'panel', 'internalBadge'];

  declare readonly selectTarget: HTMLSelectElement;
  declare readonly panelTargets: HTMLElement[];
  declare readonly internalBadgeTarget: HTMLElement;

  /**
   * Show the panel of the selected media type
   */
  select() {
    const selectedIndex = this.selectTarget.selectedIndex;
    const selectedOption = this.selectTarget.options[selectedIndex];

    this.panelTargets.forEach((panel, index) => {
      panel.classList.toggle('hidden', index !== selectedIndex);
    });
    this.internalBadgeTarget.classList.toggle(
      'hidden',
      selectedOption?.dataset.internal !== 'true'
    );
  }
}

application.register('openapi-ui--media-type-switch', MediaTypeSwitchController);
